import { Injectable, inject } from '@angular/core';
import { SignalsStoreService } from '../../../shared/signals-store.service';
import { OrderService } from '../../../shared/order.service';
import { LocalStorageService } from '../../../shared/local-storage.service';
import { Session } from '../../../shared/types/session.type';
import { FIREBASE_COLLECTIONS, LOCALSTORAGE_KEYS } from '../../../shared/constants/databases';
import { SubscriptionPayload } from '../../../settings/account/subscriptions/subscriptions.types';
import { SubscriptionsService } from '../../../settings/account/subscriptions/subscriptions.service';
import { finalize, tap } from 'rxjs';
import { FirebaseCrudService } from '../../../shared/firebase-crud.service';
import { LoadingService } from '../../../shared/loading.service';

@Injectable({
  providedIn: 'root'
})
export class PaymentMethodSignupService {

  //#region Services

  #localStorageService = inject(LocalStorageService);

  #signalsStoreService = inject(SignalsStoreService);

  #orderService = inject(OrderService);

  #subscriptionService = inject(SubscriptionsService);

  #firebaseCrudService = inject(FirebaseCrudService);

  private loadingService = inject(LoadingService);

  //#endregion

  //#region Methods

  constructor() { }

  updateSubscription(getOrder = false) {

    return new Promise<void>(async resolve => {

      let session: Session | null = this.#localStorageService.get(LOCALSTORAGE_KEYS.SESSION);
      if (!session)
        return resolve();

      const product = this.#signalsStoreService.firebaseOrder();

      // await this.#firebaseCrudService
      //   .update(
      //     FIREBASE_COLLECTIONS.ERROR_SIGNUP,
      //     session.accountInfo.id,
      //     {
      //       datePaymentMethod: new Date().toUTCString(),
      //       productInFB: product ?? {},
      //       step: 'paymentMethod'
      //     }
      //   );

      if (!product?.products?.subscription?.[0])
        return resolve();

      const info = product.products.subscription[0];

      const subs: SubscriptionPayload = {
        frequencyId: info.subscription.frequency.id,
        quantity: info.quantity,
        variantId: info.variant.id,
        packageId: info.package?.id ?? null,
        startDate: session.deliveryInfo?.deliveryDate ?? ''
      };

      return this.#subscriptionService
        .create(subs)
        .pipe(
          tap(async () => {

            // if (!getOrder) this.loadingService.open();

            // await this.#firebaseCrudService
            //   .update(
            //     FIREBASE_COLLECTIONS.ERROR_SIGNUP,
            //     session.accountInfo.id,
            //     {
            //       dateSubscriptionCreated: new Date().toUTCString(),
            //       step: 'subscriptionCreated'
            //     }
            //   );

            await this.#firebaseCrudService.delete(FIREBASE_COLLECTIONS.ORDERS, session.accountInfo.id.toString())
            this.#signalsStoreService.firebaseOrder.set([]);

            this.#signalsStoreService.getAndSyncCart();

            if (getOrder)
              this.#orderService.getOrder();

            if (session.subscriptionRequirement)
              session.subscriptionRequirement.subscriptionRequirementMet = true;

            this.#localStorageService.set(LOCALSTORAGE_KEYS.SESSION, session);

            resolve();
          }),
        )
        .subscribe();
    });
  }

  //#endregion
}
